import React from 'react';

import { CancelBooking, Checkout, ServiceDetailsRedirect, DynamicServiceDetails } from './views';
import Success from './views/success-view';
import DynamicEventDetails from './views/dynamic-event-details-view';

const routes = [
  {
    path: '/',
    exact: true,
    view: <ServiceDetailsRedirect />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
  {
    path: '/shop/:shopid/Rental_out',
    exact: true,
    view: <DynamicServiceDetails action="Rental_out" />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
  {
    // legacy URL `/bike-sub-pick_up` → treat like “Rental_out”
    path: '/shop/:shopid/bike-sub-pick_up',
    exact: true,
    view: <DynamicServiceDetails action="Rental_out" />,
    meta: { title: 'MIOO Cykelservice' },
  },
  {
    path: '/shop/:shopid/Rental_in',
    exact: true,
    view: <DynamicServiceDetails action="Rental_in" />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
  {
    // legacy URL `/bike-sub-drop_off` → treat like “Rental_in”
    path: '/shop/:shopid/bike-sub-drop_off',
    exact: true,
    view: <DynamicServiceDetails action="Rental_in" />,
    meta: { title: 'MIOO Cykelservice' },
  },
  {
    path: '/shop/:shopid',
    exact: true,
    view: <DynamicServiceDetails />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
  {
    path: '/event/:slug',
    exact: true,
    view: <DynamicEventDetails />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
  {
    path: '/checkout',
    view: <Checkout />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
  {
    path: '/success',
    view: <Success />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
  {
    path: '/cancel-service/:token/:encoded/:slug?',
    view: <CancelBooking />,
    meta: {
      title: 'MIOO Cykelservice',
    },
  },
];

export default routes;
